<style lang="scss" scoped>
  @import "details";
  .search-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-form-item{
      margin-bottom:0;
    }
  }
  .record-details{
    display: flex;
    align-items: center;
    .title{
      width:150px;
      text-align: center;
    }
    dl{
      flex:1;
      border-left: 1px solid #E4E6EA;
      dd{
        height: 42px;
        line-height: 42px;
        border-bottom: 1px solid #E4E6EA;
        &:last-child{
          border: 0;
        }
      }
    }
  }
</style>
<style lang="scss">
  .user-details .el-table__expanded-cell[class*=cell]{
    padding:0 !important;
  }
</style>
<template>
  <div class="user-details">
    <section class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">用户中心</el-breadcrumb-item>
        <el-breadcrumb-item><router-link to="/user/primer">引物合成订单</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>引物合成订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <h3 class="title">引物合成订单详情<span :style="{fontSize: '14px', marginLeft: '20px', cursor: 'pointer'}"><a @click="viewContract">《服务协议》</a></span></h3>
      <ul class="text-lists">
        <li v-show="isHeadMan"><span>关联用户：</span>{{details.customerName}}</li>
        <li><span>订单创建者：</span>{{details.createUserName}}</li>
        <li><span>订单创建时间：</span>{{basic.createTime | rTime}}</li>
        <li><span>实验基地：</span>{{details.baseName}}</li>
        <li><span>收货地址：</span>{{basic.raProvince}}{{basic.raCity}}{{basic.raCounty}}{{basic.raAddress}}</li>
      </ul>
      <div v-if="details.value.customerRemark">
        <div style="font-size: 16px;font-weight: 700;padding: 6px 0">客户备注</div>
        <p>{{details.value.customerRemark}}</p>
      </div>
      <div style="margin-top: 10px;">注：客户应自收到发票之日起3个月内支付费用，双方有其他约定的以另行约定为准</div>
      <el-table
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        class="mt20"
        border
        :data="orderTable">
        <el-table-column
          width="200"
          label="订单编号">
          <template slot-scope="scope">
            <div>{{scope.row.no}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeNum"
          label="引物条数">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="订单金额（元）">
          <template slot-scope="scope">
            <span v-if="scope.row.settlementAmount">{{scope.row.settlementAmount | amount}}</span>
            <span v-else>待询价</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="订单状态">
        </el-table-column>
        <el-table-column
          prop="settlementStatusName"
          label="结算状态">
        </el-table-column>
        <el-table-column
          prop="settlementAmounts"
          label="已结算金额（元）">
          <template slot-scope="scope">
            <span>{{(scope.row.settlementAmounts/100).toFixed(2)}}</span>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          label="结算后获取积分">-->
<!--          <template slot-scope="scope">{{scope.row.integralNumber | tableNone}}</template>-->
<!--        </el-table-column>-->
        <el-table-column prop="unlockPoints" label="已解锁积分" >
        </el-table-column>
        <el-table-column
          prop="lockPoints"
          label="未解锁积分">
          <template slot="header">
            <span>未解锁积分</span>
            <el-tooltip class="item" effect="dark" content="本次赠送积分，以最终订单结算为准" placement="top">
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            {{scope.row.lockPoints}}
          </template>
        </el-table-column>
        <el-table-column
          prop="shippedStatusName"
          label="配送状态">
        </el-table-column>
      </el-table>
      <h3 class="title">订单包含引物信息</h3>     
      <a class="pointer" @click="getPrimerExcel"><span class="el-icon-download"></span>合成报告单下载</a>
      <el-table
        border
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        class="mt20"
        :data="primerLists">
        <el-table-column width="200" 
          label="子订单号" 
          prop="childNo">
        </el-table-column>
        <el-table-column
          width="160"
          label="反应工单号">
          <template slot-scope="scope">
            {{scope.row.value | modifyNoOne(scope.row.value)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="value.name"
          label="引物名称">
        </el-table-column>
        <el-table-column
          prop="value.sequence"
          width="200"
          label="引物序列">
        </el-table-column>
        <el-table-column
          prop="value.odNum"
          label="OD/Tube">
        </el-table-column>
        <el-table-column
          prop="value.fzNum"
          label="Tube">
        </el-table-column>
        <el-table-column
          prop="value.purificationWay"
          label="纯化方式">
        </el-table-column>
        <el-table-column
          label="5端修饰">
          <template slot-scope="scope">{{scope.row.value.modify5 | tableNone}}</template>
        </el-table-column>
        <el-table-column
          label="3端修饰">
          <template slot-scope="scope">{{scope.row.value.modify3 | tableNone}}</template>
        </el-table-column>
        <el-table-column
          label="中间修饰">
          <template slot-scope="scope">{{scope.row.value.modifyMid | tableNone}}</template>
        </el-table-column>
        <el-table-column label="硫代个数">           
           <template slot-scope="scope">
            {{scope.row.value.thioNum}}
            <!-- {{baseMethods.getCharCount(scope.row.value.sequence,'*')}} -->
            </template>
        </el-table-column>
        <el-table-column prop="settlementStatus" label="结算状态">
        </el-table-column>
        <el-table-column prop="value.remark" label="备注">
        </el-table-column>
      </el-table>
      <div class="page tr">
        <el-pagination
          layout="prev, pager, next"
          :total="primerTotal"
          @current-change="changePrimerPage">
        </el-pagination>
      </div>
      <h3 class="title distribution-title" @click="showDistribution = !showDistribution">配送记录<span class="el-icon-arrow-down" :class="{active: !showDistribution}"></span></h3>
      <div v-show="showDistribution">
        <el-table
          :data="sendLists"
          border>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="record-details">
                <div class="title">引物名称</div>
                <dl>
                  <dd v-for="item in scope.row.items" :key="item.id">{{item.goodsName}}</dd>
                </dl>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="配送单号"
            prop="code">
          </el-table-column>
          <el-table-column
            prop="sendStatusName"
            label="配送状态">
          </el-table-column>
          <el-table-column
            label="配送方式"
            prop="sendTypeName">
          </el-table-column>
          <el-table-column
            label="配送员/运单号">
            <template slot-scope="scope">
              <div v-if="scope.row.sendType === 'SENDER'">{{scope.row.sender && scope.row.sender.realName}}</div>
              <div v-else>{{scope.row.deliveryCode}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="配送完成时间">
            <template slot-scope="scope">{{scope.row.finishSendDate | rTime}}</template>
          </el-table-column>
        </el-table>
        <div class="page tr">
        <el-pagination
          :page-size="10"
          :pager-count="10"
          layout="prev, pager, next"
          :total="sendTotal"
          @current-change="changeSendPage">
        </el-pagination>
      </div>
      </div>
    </section>
  </div>
</template>

<script>
import { primerOrderDetail, primerInfo, primerSendOrders, sendOrdersDetails, primerExcel } from '@/services/api.index'
import {
  tableHeaderStyle,
  tableCellStyle
} from '@/settings/table'
export default {
  data () {
    return {
      tableHeaderStyle,
      tableCellStyle,
      details: {},
      primerLists: [],
      basic: {},
      orderTable: [],
      primerId: this.$route.query.id,
      primerTotal: 0,
      primerPage: 0,
      primerSize: 10,
      showDistribution: true,
      sendLists: [],
      sendTotal: 0,
      sendPage: 0,
      sendSize: 10,
      isHeadMan: this.baseMethods.isHeadMan(),
      orderCodes: []
    }
  },
  created() {
    this.getDetail()
  },
  filters: {
    modifyNoOne(value) {
      if(value.modifyNo){
        return value.modifyNo
      }else{
        return value.no
      }
    }
  },
  methods: {
    // 引物详情
    getDetail () {
      primerOrderDetail(this.primerId).then(res => {
        this.details = res.data

        let value = res.data.value
        value.primeNum = res.data.primeNum
        let statusName = res.data.userWebOrderStatus==='OK'?'结单':this.baseMethods.orderStatus(res.data.userWebOrderStatus) 
        value.statusName = statusName 
        value.settlementStatusName = this.baseMethods.settlementStatus(value.settlementStatus)
        value.shippedStatusName = this.baseMethods.shippedStatus(res.data.userWebShippedStatus)
        value.unlockPoints = res.data.unlockPoints >= 0 ? res.data.unlockPoints : '-'
        value.lockPoints = res.data.lockPoints >= 0 ? res.data.lockPoints : '-'
        this.basic = value
        this.basic.settlementAmounts =  this.details.settlementAmounts? this.details.settlementAmounts:''
        this.orderTable = this.orderTable.concat(this.basic)
        this.getPrimerInfo()
      })
    },
    viewContract() {
      window.open(process.env.SHOP_URL + `/article/detail/14_0`)
    },
    // 引物信息
    getPrimerInfo () {
      const { primerId, primerPage, primerSize } = this
      primerInfo(primerId, primerPage, primerSize).then(res => {
        this.orderCodes = []
        this.primerLists = res.data.list
        this.primerTotal = res.data.totalCount
        this.primerLists.forEach(v => {
          v.childNo = v.childNo ? v.childNo : this.details.value.no
          v.settlementStatus = this.baseMethods.settlementStatus(v.settlementStatus)
          this.orderCodes.push(v.childNo);
          this.orderCodes = [...new Set(this.orderCodes)]
        })
        this.getSendOrders()
      })
    },
    // 配送记录
    getSendOrders () {
      const { sendPage, sendSize, details } = this;
      let params = {}
      if (this.orderCodes.length === 1) {
        params = {
          page: sendPage,
          size: sendSize,
          orderCode: details.value.no
        }
      } else {
        params = {
          page: sendPage,
          size: sendSize,
          orderCodes: this.orderCodes.join()
        }
      }
      primerSendOrders(params).then(async res => {
        await Promise.all(res.data.map(async item => {
          item.sendStatusName = this.baseMethods.sendStatus(item.sendStatus)
          item.sendTypeName = this.baseMethods.sendType(item.sendType)
          item.items = (await sendOrdersDetails(item.id)).data
        }))
        this.sendLists = res.data
        this.sendTotal = this.baseMethods.getTotal(res)
      })
    },
    getPrimerExcel () {
      primerExcel(this.primerId).then(res => {
        this.baseMethods.downloadFile(res.data, '合成报告单')
      })
    },
    // 翻页
    changePrimerPage (value) {
      this.primerPage = value - 1
      this.getPrimerInfo()
    },
    changeSendPage (value) {
      this.sendPage = value - 1
      this.getSendOrders()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/primer_details.vue